// Game utility functions for AddemNumbers

let problemIdCounter = 0;

export const generateProblem = (range) => {
    const n1 = Math.floor(Math.random() * (range.max - range.min + 1)) + range.min;
    const n2 = Math.floor(Math.random() * (range.max - range.min + 1)) + range.min;
    
    return {
        id: ++problemIdCounter,
        n1,
        n2,
        answer: n1 + n2
    };
};

